import PropTypes from "prop-types";
import styled from "styled-components";
import { Col, Row } from "react-bootstrap";

import { Placeholder } from "components/Placeholder";

const HistoricalPerformanceChartPlaceholderContainer = styled.div`
  padding: 6px 20px;

  .header {
    width: 100%;

    .placeholder-glow {
      flex: 1;
    }

    .total .placeholder-custom {
      min-height: 2rem;
    }

    .legend .placeholder-custom {
      min-height: 2rem;
    }
  }

  .chart-wrapper {
    margin-top: 30px;

    .placeholder-custom {
      min-height: ${({ height }) =>
        height ? `calc(${height} - 80px)` : "310px"};
    }
  }

  .filter-wrapper {
    margin-top: 10px;
  }

  @media (max-width: 768px) {
    .header {
      flex-direction: column-reverse;
    }

    .chart-wrapper {
      margin-top: 0;

      .placeholder-custom {
        min-height: 350px;
      }
    }
  }
`;

export const HistoricalPerformanceChartPlaceholder = ({
  height,
  legendContent,
}) => {
  return (
    <HistoricalPerformanceChartPlaceholderContainer
      height={height}
      className="placeholder-container"
    >
      <Row className="header">
        <Col md={4}>
          <div className="total">
            <Placeholder
              size="lg"
              col={{ lg: 8, xs: 6 }}
              className="placeholder-custom"
            />
          </div>
          <Placeholder size="lg" col={{ lg: 8, xs: 6 }} as="p" />
        </Col>
        {legendContent && (
          <Col md={8} className="legend">
            <Placeholder
              size="lg"
              col={{ lg: 6, xs: 12 }}
              as="p"
              className="placeholder-custom"
            />
          </Col>
        )}
      </Row>

      <div className="chart-wrapper">
        <Placeholder
          size="lg"
          col={{ xs: 12 }}
          className="placeholder-custom"
        />
      </div>
      <div className="filter-wrapper">
        <Placeholder size="lg" col={{ xs: 12, lg: 6 }}></Placeholder>
      </div>
    </HistoricalPerformanceChartPlaceholderContainer>
  );
};

HistoricalPerformanceChartPlaceholder.propTypes = {
  height: PropTypes.string,
  legendContent: PropTypes.object,
};
